// extracted by mini-css-extract-plugin
export default {"EmbedCount":"EmbedCount_EmbedCount__k31sm","count":"EmbedCount_count__GG4Rm"};